import { takeLatest, call, put } from 'redux-saga/effects'
import { GET_BOOKINGS } from './actionTypes'
import { setLoader } from '../loader/actions'
import { setBookings } from './actions'
import bookingsService from '../../supabaseServices/BookingService'

export function* getBookingsSagaFn() {
  try {
    yield put(setLoader(true))
    const res = yield call(bookingsService.getPaginatedBookings, 1)
    yield put(setBookings(res))
  } catch (error) {
    console.log(error)
  } finally {
    yield put(setLoader(false))
  }
}

export default function* bookingSaga() {
  yield takeLatest(GET_BOOKINGS, getBookingsSagaFn)
}
